import React, { useState } from 'react';
import RewardsModal from './modals/RewardsModal';
import WalletConnect from './WalletConnect';
// import { AdBanner } from './ads'; // Disabled for now
import useWallet from '../hooks/useWallet';
import Button from './Button';

const Lobby = ({ username, setUsername, currentRoom, setCurrentRoom, onJoinGame, connectionStatus }) => {
  const [roomError, setRoomError] = useState('');
  const [showRewardsModal, setShowRewardsModal] = useState(false);
  const [activeTab, setActiveTab] = useState('public'); // New state for tab management

  // Use new AppKit wallet hook
  const {
    isConnected: isWalletConnected,
    // address: walletAddress,
    isNetworkSupported,
  } = useWallet();

  // AppKit handles wallet connection automatically

  const handlePublicMatch = () => {
    const currentUsername = localStorage.getItem('username') || username;
    
    if (!currentUsername || !currentUsername.trim()) {
      alert('Please set a username first! Go to Dashboard to set your username.');
      return;
    }

    if (!isWalletConnected) {
      alert('Please connect your wallet first!');
      return;
    }

    if (!isNetworkSupported) {
      alert('Please switch to a supported network!');
      return;
    }

    onJoinGame();
  };

  const handlePrivateMatch = () => {
    const currentUsername = localStorage.getItem('username') || username;
    
    if (!currentUsername || !currentUsername.trim()) {
      alert('Please set a username first! Go to Dashboard to set your username.');
      return;
    }

    if (!isWalletConnected) {
      alert('Please connect your wallet first!');
      return;
    }

    if (!isNetworkSupported) {
      alert('Please switch to a supported network!');
      return;
    }

    if (!currentRoom.trim()) {
      setRoomError('Please enter a room ID to create or join');
      return;
    }

    setRoomError('');
    onJoinGame(currentRoom);
  };

  const handleShare = (platform) => {
    const shareUrl = location.href + (currentRoom && `#${currentRoom}`);
    const shareText = "Let's play Bomberman Together!";

    switch (platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${shareText}%20${shareUrl}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(shareUrl);
        alert('Link copied to clipboard!');
        break;
      case 'instagram':
      case 'native':
      default:
        if (navigator.share) {
          navigator.share({
            title: 'Check this out!',
            text: shareText,
            url: shareUrl,
          });
        }
    }
  };

  const getButtonText = (baseText) => {
    const currentUsername = localStorage.getItem('username') || username;
    
    if (!currentUsername || !currentUsername.trim()) {
      return `${baseText} (Set Username First)`;
    }
    if (!isWalletConnected) {
      return `${baseText} (Connect Wallet First)`;
    }
    if (!isNetworkSupported) {
      return `${baseText} (Switch Network)`;
    }
    return baseText;
  };

  return (
    <div className='min-h-screen flex items-center justify-center p-2 sm:p-4'>
      <div className='w-full max-w-2xl'>
        <div className='bg-gray-900/80 backdrop-blur-lg rounded-xl sm:rounded-2xl border border-gray-700/50 p-4 sm:p-6 lg:p-8 shadow-2xl'>
          {/* Header */}
          <div className='text-center mb-6 sm:mb-8'>
            <p className='text-2xl sm:text-3xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent mb-2'>
              Bomberman Hunt
            </p>
            <p className='text-gray-300 text-sm sm:text-md'>Choose your battleground and start the hunt!</p>
          </div>

          {/* Connection Status */}
          <div className='flex items-center justify-center mb-6 sm:mb-8'>
            <div
              className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 rounded-full border ${
                connectionStatus === 'connected'
                  ? 'bg-emerald-500/20 border-emerald-500/50 text-emerald-300'
                  : connectionStatus === 'disconnected'
                  ? 'bg-red-500/20 border-red-500/50 text-red-300'
                  : 'bg-yellow-500/20 border-yellow-500/50 text-yellow-300'
              }`}>
              <div
                className={`w-2 h-2 rounded-full ${
                  connectionStatus === 'connected'
                    ? 'bg-emerald-400'
                    : connectionStatus === 'disconnected'
                    ? 'bg-red-400'
                    : 'bg-yellow-400'
                } animate-pulse`}></div>
              <span className='text-xs sm:text-sm font-medium'>
                {connectionStatus === 'connected'
                  ? 'Connected to server'
                  : connectionStatus === 'disconnected'
                  ? 'Disconnected'
                  : 'Connecting...'}
              </span>
            </div>
          </div>

          {/* Banner Ad - Disabled for now */}
          {/* <div className='mb-6 sm:mb-8'>
            <AdBanner provider="auto" format="horizontal" className="hidden md:block" />
          </div> */}

          {/* Wallet Connection
          <div className='mb-8'>
            <h3 className='text-lg font-bold text-white mb-4 text-center'>Connect Your Wallet</h3>
            <div className='flex justify-center'>
              <WalletConnect className='w-full max-w-md' />
            </div>
          </div> */}

          {/* Tab Navigation */}
          <div className='mb-6 sm:mb-8'>
            <div className='flex bg-gray-800/50 rounded-xl p-1 border border-gray-600/50'>
              <button
                className={`flex-1 flex items-center justify-center gap-1 sm:gap-2 py-2 sm:py-3 px-2 sm:px-4 rounded-lg transition-all duration-200 font-medium text-sm sm:text-base ${
                  activeTab === 'public'
                    ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/25'
                    : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                }`}
                onClick={() => setActiveTab('public')}>
                <i className='fas fa-globe'></i>
                <span className='hidden sm:inline'>Public Room</span>
                <span className='sm:hidden'>Public</span>
              </button>
              <button
                className={`flex-1 flex items-center justify-center gap-1 sm:gap-2 py-2 sm:py-3 px-2 sm:px-4 rounded-lg transition-all duration-200 font-medium text-sm sm:text-base ${
                  activeTab === 'private'
                    ? 'bg-purple-500 text-white shadow-lg shadow-purple-500/25'
                    : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                }`}
                onClick={() => setActiveTab('private')}>
                <i className='fas fa-lock'></i>
                <span className='hidden sm:inline'>Private Room</span>
                <span className='sm:hidden'>Private</span>
              </button>
            </div>
          </div>

          {/* Tab Content */}
          <div className='mb-6 sm:mb-8'>
            {activeTab === 'public' && (
              <div className='space-y-4 sm:space-y-6'>
                <div className='text-center'>
                  <h3 className='text-lg sm:text-xl font-bold text-white mb-2'>Join Public Match</h3>
                  <p className='text-gray-400 text-sm sm:text-base'>Battle with random players from around the world!</p>
                </div>
                {/* Username Input */}
                <div className='mb-6 sm:mb-8'>
                  <label htmlFor='username-input' className='block text-white text-base mb-2 sm:mb-3'>
                    Your Username:
                  </label>
                  <input
                    type='text'
                    id='username-input'
                    readOnly
                    className='w-full bg-gray-800/50 border border-gray-600/50 text-white placeholder-gray-400 rounded-xl px-3 sm:px-4 py-3 sm:py-4 text-base sm:text-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200'
                    placeholder='Enter your username'
                    // value={username}
                    value={localStorage.getItem('username') || ''}
                    onChange={(e) => setUsername(e.target.value)}
                    maxLength={20}
                  />
                  {!localStorage.getItem('username') && (
                    <div className='mt-2 p-3 bg-yellow-500/20 border border-yellow-500/50 rounded-lg text-yellow-300 text-xs sm:text-sm'>
                      ⚠️ No username set! Please go to Dashboard to set your username first.
                    </div>
                  )}
                </div>
                <button
                  disabled={!isWalletConnected || !isNetworkSupported || !localStorage.getItem('username')}
                  onClick={handlePublicMatch}
                  // className='w-full py-4 text-lg font-bold'
                  className='w-full py-3 sm:py-4 text-base sm:text-lg font-bold bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 disabled:from-gray-600 disabled:to-gray-700 disabled:cursor-not-allowed rounded-xl transition-all duration-200'
                  >
                  {getButtonText("Let's Hunt!")}
                </button>
              </div>
            )}

            {activeTab === 'private' && (
              <div className='space-y-4 sm:space-y-6'>
                <div className='text-center'>
                  <h3 className='text-lg sm:text-xl font-bold text-white mb-2'>Create Private Room</h3>
                  <p className='text-gray-400 text-sm sm:text-base'>Create a custom room to play with your friends!</p>
                </div>
                <div className='mb-4 sm:mb-6'>
                  <label htmlFor='username-input' className='block text-white text-base mb-2 sm:mb-3'>
                    Your Username:
                  </label>
                  <input
                    type='text'
                    id='username-input'
                    readOnly
                    className='w-full bg-gray-800/50 border border-gray-600/50 text-white placeholder-gray-400 rounded-xl px-3 sm:px-4 py-3 sm:py-4 text-base sm:text-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200'
                    placeholder='Enter your username'
                    value={localStorage.getItem('username') || ''}
                    onChange={(e) => setUsername(e.target.value)}
                    maxLength={20}
                  />
                  {!localStorage.getItem('username') && (
                    <div className='mt-2 p-3 bg-yellow-500/20 border border-yellow-500/50 rounded-lg text-yellow-300 text-xs sm:text-sm'>
                      ⚠️ No username set! Please go to Dashboard to set your username first.
                    </div>
                  )}
                </div>
                <div>
                  <label htmlFor='room-id-input' className='block text-white text-base mb-2 sm:mb-3'>
                    Room ID:
                  </label>
                  <input
                    type='text'
                    id='room-id-input'
                    className='w-full bg-gray-800/50 border border-gray-600/50 text-white placeholder-gray-400 rounded-xl px-3 sm:px-4 py-3 sm:py-4 text-base sm:text-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200'
                    placeholder='Enter your room ID'
                    value={currentRoom}
                    onChange={(e) => setCurrentRoom(e.target.value)}
                    maxLength={20}
                  />
                  {roomError && (
                    <div className='mt-2 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-300 text-xs sm:text-sm'>
                      {roomError}
                    </div>
                  )}
                </div>

                <button
                  onClick={handlePrivateMatch}
                  disabled={!isWalletConnected || !isNetworkSupported || !localStorage.getItem('username')}
                  className='w-full py-3 sm:py-4 text-base sm:text-lg font-bold bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 disabled:from-gray-600 disabled:to-gray-700 disabled:cursor-not-allowed rounded-xl transition-all duration-200'>
                  {getButtonText('Hunt Your Friends!')}
                </button>
              </div>
            )}
          </div>

          {/* Share Section */}
          <div className='border-t border-gray-700/50 pt-4 sm:pt-6 lg:pt-8'>
            {/* <h3 className='text-center text-white text-md mb-2'>Share the game with your friends:</h3> */}
            <div className='flex justify-center gap-2 sm:gap-3 lg:gap-4 flex-wrap'>
              {[
                { icon: 'fas fa-copy', action: 'copy', bg: 'bg-gray-600 hover:bg-gray-500' },
                { icon: 'fab fa-whatsapp', action: 'whatsapp', bg: 'bg-green-600 hover:bg-green-500' },
                { icon: 'fab fa-facebook', action: 'facebook', bg: 'bg-blue-600 hover:bg-blue-500' },
                { icon: 'fab fa-twitter', action: 'twitter', bg: 'bg-sky-600 hover:bg-sky-500' },
                { icon: 'fab fa-instagram', action: 'instagram', bg: 'bg-pink-600 hover:bg-pink-500' },
                { icon: 'fas fa-share-nodes', action: 'native', bg: 'bg-purple-600 hover:bg-purple-500' },
              ].map((social) => (
                <button
                  key={social.action}
                  className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl ${social.bg} text-white transition-all duration-200 transform hover:scale-110 shadow-lg flex items-center justify-center`}
                  onClick={() => handleShare(social.action)}
                  title={`Share via ${social.action}`}>
                  <i className={`${social.icon} text-sm sm:text-lg`}></i>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Rewards Modal */}
      <RewardsModal show={showRewardsModal} onClose={() => setShowRewardsModal(false)} />
    </div>
  );
};

export default Lobby;
